import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private config: Map<string, any>;

  constructor(private http: HttpClient) {
    this.config = new Map<string, string>([]);
    for (let [key, value] of Object.entries(environment)) {
      this.config.set(key, value);
    }
  }

  init(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http.get('./assets/config.json').toPromise().then(data => {
        for (let [key, value] of Object.entries(data)) {
          if (this.config.has(key)) {
            continue;
          }
          this.config.set(key, value);
        }
        return this.http.get('./assets/yourgls-allowed-languages.properties', { responseType: 'text' }).toPromise()
          .then(text => {
            const parsed = this.parseAllowedLanguages(text);
            if (parsed.defaultLocale && !this.config.has('default_locale')) {
              this.config.set('default_locale', parsed.defaultLocale);
            }
            if (parsed.allowedLocales.length && !this.config.has('allowed_languages')) {
              this.config.set('allowed_languages', parsed.allowedLocales);
            }
            if (parsed.allowedLocalesDefault && !this.config.has('allowed_locales_default')) {
              this.config.set('allowed_locales_default', parsed.allowedLocalesDefault);
            }
          })
          .catch(() => undefined);
      }).then(() => resolve()).catch(err => reject(err));
    });
  }

  get<T extends any>(key: string): T {
    return this.config.get(key) as T;
  }

  private parseAllowedLanguages(text: string): { defaultLocale: string | null; allowedLocales: string[]; allowedLocalesDefault: string | null } {
    const lines = text.split(/\r?\n/);
    const allowedLocales: string[] = [];
    let defaultLocale: string | null = null;
    let allowedLocalesDefault: string | null = null;

    for (const line of lines) {
      const trimmed = line.trim();
      if (!trimmed) {
        continue;
      }

      if (trimmed.startsWith('default=')) {
        defaultLocale = trimmed.slice('default='.length).trim() || null;
        continue;
      }

      if (trimmed.startsWith('locale_default=')) {
        defaultLocale = trimmed.slice('locale_default='.length).trim() || null;
        continue;
      }

      if (trimmed.startsWith('allowed_locales_default=')) {
        allowedLocalesDefault = trimmed.slice('allowed_locales_default='.length).trim() || null;
        continue;
      }

      allowedLocales.push(trimmed);
    }

    return { defaultLocale, allowedLocales, allowedLocalesDefault };
  }
}
